import { getSegmentPriceDiffPercent } from '@/utils/search/segmentPrices/segmentPrices'

export const formatSegmentPriceDiff = (
  price: number,
  contextPrice: number | null | undefined
) => {
  const diff = getSegmentPriceDiffPercent(price, contextPrice)
  if (diff === null) return null
  const value = Math.abs(diff).toLocaleString('ru-RU', {
    maximumFractionDigits: 1,
  })
  if (diff === 0) return { text: '0%', direction: 'same' as const }
  return diff < 0
    ? { text: `−${value}%`, direction: 'cheaper' as const }
    : { text: `+${value}%`, direction: 'pricier' as const }
}
